import { Component, inject, ViewChild } from '@angular/core'
import { AuthService } from '../services/auth/auth.service'
import { LoggedUser } from '../models/loggedInUser.model'
import { TranslateModule } from '@ngx-translate/core'
import { PasswordChangeComponent } from '../helpers/password-change/password-change.component'
import { environment } from '../../environments/environment'

@Component({
    selector: 'app-account-data',
    templateUrl: './account-data.component.html',
    styleUrl: './account-data.component.scss',
    imports: [TranslateModule, PasswordChangeComponent],
})
export class AccountDataComponent {
    public userName: string | null = null
    public canChangePassword = false

    @ViewChild('passwordChangeModal') passwordChangeModal!: PasswordChangeComponent

    constructor(private _authService: AuthService) {
        const loggedInUser: LoggedUser | null = this._authService.getUserResult()
        if (loggedInUser != null) {
            this.userName = loggedInUser.userName
            this.canChangePassword =
                loggedInUser.tipologiaAutenticazione.toString() === environment.authenticationType
        }
    }

    openPasswordChangeDialog() {
        this.passwordChangeModal.open()
    }

    logout() {
        this._authService.logout()
    }
}
